//--------------- EXPORT DO UTILITÁRIO STATUS VENDA PAGO ---------------//
// Espelho de SALE_STATUS.APPROVED do backend (config/constants.js): Hotmart grava em
// inglês (APPROVED, COMPLETE e o COMPLETED antigo = garantia de 7 dias passou),
// Kiwify/Lastlink em português (APROVADO, EFETIVADO).
const STATUS_PAGOS = new Set(["APPROVED", "COMPLETE", "COMPLETED", "APROVADO", "EFETIVADO"]);

export default function statusVendaPago(status) {
  return STATUS_PAGOS.has(String(status || "").toUpperCase());
}
